import { STATIC_VALUES } from '@common/constants/index';
import { AppInfo, ClientProps } from 'click-types';

const getCurrentUrl = () => {
  try {
    return (
      localStorage.getItem('click__current_url') ||
      window.parent?.location.href ||
      window.location.href
    );
  } catch (e) {
    console.error('===getCurrentUrl ERROR', e);
    return window.location.href;
  }
};

const getCookie = () => {
  try {
    return (
      localStorage.getItem('click__cookie') ||
      window.parent?.document.cookie ||
      document.cookie ||
      ''
    );
  } catch (e) {
    console.error('===getCookie ERROR', e);
    return document.cookie;
  }
};

const getUserAgent = () => {
  return navigator.userAgent;
};
/**
 * Make a `ClientProps` object from a object containing all the environment variables.
 *
 * @param dependencies
 * @returns a ClientProps object
 */
export function makeClientPropsFromDependencies(
  dependencies: Record<string, any> = {}
): ClientProps {
  const appInfo: AppInfo = {
    name: dependencies.appInfor.APP_NAME,
    version: dependencies.appInfor.APP_VERSION,
  };
  const clientProps: ClientProps = {
    appInfo: appInfo,
    timeZone: dependencies.timeZone,
    locale: dependencies.locale,
    currentLocation: {
      latitude: dependencies.currentLocation?.lat,
      longitude: dependencies.currentLocation?.lng,
    },
    routeParams: dependencies.routeParam,
    listIds: dependencies.currentListIds,
    valueInputs: dependencies.valueInputs,
    createRecordId: dependencies.createRecordId,
    sortedItemNumber: dependencies.sortedItemNumber,
    univaPaySubscriptionId: dependencies.idUnivaPaySubscription,
    transactionId: dependencies.transactionId,
    customActions: dependencies.customActions,
    scannerId: dependencies.scannerId,
    // add user-agent, current-url, cookie value
    ...(dependencies.staticValues.includes(STATIC_VALUES.CURRENT_URL)
      ? {
          currentUrl: getCurrentUrl(),
        }
      : {}),
    ...(dependencies.staticValues.includes(STATIC_VALUES.USER_AGENT)
      ? {
          userAgent: getUserAgent(),
        }
      : {}),
    ...(dependencies.staticValues.includes(STATIC_VALUES.COOKIE_VALUE)
      ? {
          cookie: getCookie(),
        }
      : {}),
  };
  return clientProps;
}
